export default "__VITE_ASSET__CTtjLIOv__"